// React
import React, { Component } from 'react'

// Libraries
import { Provider } from 'react-redux'

// Components
import EmbeddableCartSidebar from 'store/modules/cart/EmbeddableCart/Sidebar'
import Themed from 'store/v2/react/components/Themed'

// Shared

const store = window.booqableStore

export default class EmbeddableCartSidebarContainer extends Component {
  static displayName = 'EmbeddableCartSidebarContainer'

  render () {
    return (
      <Provider store={store}>
        <Themed>
          <div className="booqable-component" style={{ display: 'none' }}>
            <EmbeddableCartSidebar datepicker={false} />
          </div>
        </Themed>
      </Provider>
    )
  }
}
